.wrapper,
.wrapperStateScreen {
	display: flex;
	overflow: hidden;
	/*
    208px is the height of our header, BUT we also set this dynamically in the component
    so that it extends to the bottom regardless of header height
    */
	height: calc(100vh - 208px);
	background-color: var(--ds-background-neutral, var(--adg3-color-N20));
	outline: none;
	cursor: grab;
}

.dependenciesTab {
	width: 100%;
}

.container {
	display: flex;
	outline: none;
	min-width: 100%;
	min-height: 100%;
	transform-origin: left top;
	backface-visibility: hidden;
}

.wrapperStateScreen {
	align-items: center;
	justify-content: center;
}
